module.exports = __webpack_public_path__ + "img/publications.97bc884d.gif";